import React from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function MobileDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Mobile Auto Detailing',
    serviceType: 'Mobile Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Ventura County', 'Camarillo', 'Oxnard', 'Ventura', 'Thousand Oaks', 'Simi Valley', 'Moorpark', 'Newbury Park', 'Westlake Village'],
    description: 'Fully mobile car detailing throughout Ventura County. We bring the detail shop to your home or office with our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  };
  const faqs = [{
    question: 'What is mobile car detailing?',
    answer: "Mobile car detailing is a professional cleaning and restoration service that comes to you. Mike's Pro Detail brings our own water and detailing equipment to your home or office anywhere in Ventura County — no drop-off or waiting room required. We require access to a standard electrical outlet at the service location."
  }, {
    question: 'Do you bring your own water and electricity?',
    answer: 'We bring our own water and detailing equipment. We require access to a standard electrical outlet at the service location.'
  }, {
    question: 'What areas do you cover for mobile detailing?',
    answer: 'We serve all of Ventura County including Camarillo, Oxnard, Ventura, Thousand Oaks, Simi Valley, Moorpark, Newbury Park, and Westlake Village, plus select surrounding areas.'
  }, {
    question: 'How much does mobile detailing cost?',
    answer: 'Exterior details start at $160, interior at $180, and our popular full detail at $300, with adjustments for vehicle size. Call (818) 381-9905 for an exact quote.'
  }, {
    question: 'How long does mobile detailing take?',
    answer: 'A wash and wax takes about 1.5\u20132 hours, interior detailing 2\u20133 hours, and a full detail 3\u20134 hours. We never rush — quality results take proper time.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/#services'
  }, {
    name: 'Mobile Detailing',
    item: 'https://www.fulldetailpro.com/services/mobile-detailing'
  }];
  return <ServicePageLayout title="Mobile Detailing Ventura County" subtitle="The detail shop that comes to you. Professional mobile car detailing at your home or office anywhere in Ventura County — no drop-off, no waiting." metaDescription="Mobile detailing in Ventura County. Mike's Pro Detail brings interior, exterior & full car detailing to your home or office. 5-star service. Call (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-1051" data-mp="un46ig42jwaf">
      <p data-id="element-1052" data-mp="2g0ypj8gg7786">
        At Mike's Pro Detail,{' '}
        <strong data-id="element-1053" data-mp="1sxuowb3bnd4">mobile detailing in Ventura County</strong> means professional,
        showroom-quality car care delivered directly to your driveway. There's
        no need to drop your vehicle off, sit in a waiting room, or rearrange
        your day around a detail shop's hours. We bring a fully equipped
        detailing operation — complete with our own water, detailing equipment,
        and premium products — straight to your home or office, wherever you are
        in Ventura County. We require access to a standard electrical outlet at
        the service location.
      </p>

      <h2 data-id="element-1054" data-mp="3nzw4lvi74uw2">Why Choose Mobile Car Detailing?</h2>
      <p data-id="element-1055" data-mp="3ny2w0ao0w0lf">
        Mobile car detailing in Ventura County combines the highest quality
        results with unmatched convenience. Instead of automated car washes that
        scratch and swirl your paint, our technicians hand-detail every vehicle
        with meticulous care. And because we come to you, you reclaim hours of
        your day while we transform your car on-site.
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-1056" data-mp="16s46exbtw6g0">
        <li className="flex items-start" data-id="element-1057" data-mp="11s8555uimt45">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1058" data-mp="11tjhvv5xvb7e" />
          <span data-id="element-1059" data-mp="1fsiuu5k3a1nq">
            <strong data-id="element-1060" data-mp="1ft2crm9qoq1r">Total Convenience:</strong> We detail your car at your home,
            office, or apartment — you never have to leave.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1061" data-mp="1ppxba560iqg1">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1062" data-mp="1povxvu1ixrv5" />
          <span data-id="element-1063" data-mp="1krm27wnjkjyv">
            <strong data-id="element-1064" data-mp="1kq2mc75ssaxm">We Bring the Equipment:</strong> We bring our own water and
            detailing equipment. We require access to a standard electrical
            outlet at the service location.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1065" data-mp="1uhp28gt2yy6p">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1066" data-mp="28gexrs094psy" />
          <span data-id="element-1067" data-mp="28ec0qo0olweq">
            <strong data-id="element-1068" data-mp="23hlj3w98asr7">Premium, Hand-Crafted Results:</strong> Safe wash methods
            and professional-grade products on every vehicle.
          </span>
        </li>
        <li className="flex items-start" data-id="element-1069" data-mp="2n46lfu0fyrbk">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-1070" data-mp="2s302txiun2h0" />
          <span data-id="element-1071" data-mp="2s0462ciqmju5">
            <strong data-id="element-1072" data-mp="2e2z1yi2l3v1j">Flexible Scheduling:</strong> Including weekends, to fit
            your busy Ventura County lifestyle.
          </span>
        </li>
      </ul>

      <h2 data-id="element-1073" data-mp="2i2hd4m4lsrr6">Our Mobile Detailing Services</h2>
      <p data-id="element-1074" data-mp="24cdv67crbk7j">
        Every service we offer is performed on-site as part of our mobile
        detailing operation. Explore each in detail:
      </p>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-1075" data-mp="2957291vp74ms">
        <Link to="/services/interior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1076" data-mp="1ufre7tnjxdas">
          Interior Detailing &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1077" data-mp="1qd4obyafy2g8">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/full-car-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1078" data-mp="3na0qv10dbqai">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/engine-bay-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1079" data-mp="eviein3e9ol3">
          Engine Bay Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1080" data-mp="5x6oonacqutp">
          Headlight Restoration &rarr;
        </Link>
        <Link to="/services/hybrid-ceramic-spray" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-1081" data-mp="2ll6m92x8p6pv">
          Hybrid Ceramic Spray &rarr;
        </Link>
      </div>

      <h2 data-id="element-1082" data-mp="1a4c5ovwbiehu">Serving All of Ventura County</h2>
      <p data-id="element-1083" data-mp="1a3avsur1fy1p">
        Our mobile detailing service reaches every community in Ventura County.
        Find your city for local details and pricing:{' '}
        <Link to="/ventura-county/camarillo" data-id="element-1084" data-mp="1jux9qyurgb85">Camarillo</Link>,{' '}
        <Link to="/ventura-county/oxnard" data-id="element-1085" data-mp="1jwrm3oryuv0m">Oxnard</Link>,{' '}
        <Link to="/ventura-county/ventura" data-id="element-1086" data-mp="1osp0hpjo5rar">Ventura</Link>,{' '}
        <Link to="/ventura-county/thousand-oaks" data-id="element-1087" data-mp="1tt4fsmnih8vd">Thousand Oaks</Link>,{' '}
        <Link to="/ventura-county/simi-valley" data-id="element-1088" data-mp="1tqqp0pzv6itm">Simi Valley</Link>,{' '}
        <Link to="/ventura-county/moorpark" data-id="element-1089" data-mp="1xtwp1fwdvdrn">Moorpark</Link>,{' '}
        <Link to="/ventura-county/newbury-park" data-id="element-1090" data-mp="3vkptosihe1xc">Newbury Park</Link>, and{' '}
        <Link to="/ventura-county/westlake-village" data-id="element-1091" data-mp="3gfc0mtltzav">Westlake Village</Link>.
      </p>
    </ServicePageLayout>;
}